import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { reducer as formReducer } from "redux-form";
import masterParameters from "./masterParameters/reducer";
import masterDDL, {
  PropertyTypes,
  UnitTypes,
  Countries,
  Projects,
  PaymentTypes,
  PropertiesDDL,
  PaymentMonths,
  MasterBankDDL,
  MasterEmirateDDL,
} from "./masterDDL/reducer";
import { db_Ids, ui_Ids, local_payroll_values } from "./global/reducer";
import Reports, {
  ReportDetails,
  ReportGroupsDDL,
  ReportsDDL,
} from "./reports/reducer";
import Masters, { MastersTblDDL } from "./Masters/reducer";
import Users from "./users/reducer";
import Managers from "./users/managers/reducer";
import MasterTasks from "./users/masterTasks/reducer";
import UserPermissionsTask from "./users/userPermissionsTask/reducer";
import AuthReducer from "./authentication/reducer";
import Dashboard from "./users/dashboard/reducer";
import configReducer from "../store/reducer";
import PropertyBasicDetails from "./propertyRecords/basicDetails/reducer";
import PropertyExpenseRecords from "./propertyRecords/expenseRecords/reducer";
import PropertyIncomeRecords from "./propertyRecords/incomeRecords/reducer";
import PropertyMunicipalityPaymentSchedule from "./propertyRecords/municipalityPaymentSchedule/reducer";
import PropertyOwnerPaymentSchedule from "./propertyRecords/ownerPaymentSchedule/reducer";
import PropertySalesPayments from "./propertyRecords/salesPayments/reducer";
import PropertyReservationSchedule from "./propertyRecords/reservationSchedule/reducer";
import PropertyDocuments from "./propertyRecords/propertyDocuments/reducer";
import PropertyServiceCharges from "./propertyRecords/serviceCharges/reducer";
import PropertyRentRecords from "./propertyRecords/rentRecords/reducer";
import PropertyRentInstruments from "./propertyRecords/rentInstruments/reducer";
import PropertyUnitRecords from "./propertyRecords/unitRecords/reducer";
import PropertyUnitExpenseRecords from "./propertyUnitRecords/expenseRecords/reducer";
import PropertyUnitIncomeRecords from "./propertyUnitRecords/incomeRecords/reducer";
import PropertyUnitMunicipalityPaymentSchedule from "./propertyUnitRecords/municipalityPaymentSchedule/reducer";
import PropertyUnitOwnerPaymentSchedule from "./propertyUnitRecords/ownerPaymentSchedule/reducer";
import PropertyUnitReservationSchedule from "./propertyUnitRecords/reservationSchedule/reducer";
import PropertyUnitDocuments from "./propertyUnitRecords/propertyDocuments/reducer";
import PropertyUnitServiceCharges from "./propertyUnitRecords/serviceCharges/reducer";
import BankTransactions from "./bankTransactions/reducer";
const persistConfig = {
  key: "root",
  storage,
  // stateReconciler: hardSet
  // employees: ["employees"],
};
const rootReducer = (state, action) =>
  combineReducers({
    PropertyBasicDetails,
    PropertyExpenseRecords,
    PropertyIncomeRecords,
    PropertyMunicipalityPaymentSchedule,
    PropertyOwnerPaymentSchedule,
    PropertySalesPayments,
    PropertyReservationSchedule,
    PropertyRentRecords,
    PropertyRentInstruments,
    PropertyDocuments,
    PropertyServiceCharges,
    PropertyUnitRecords,
    PropertyUnitExpenseRecords,
    PropertyUnitIncomeRecords,
    PropertyUnitMunicipalityPaymentSchedule,
    PropertyUnitOwnerPaymentSchedule,
    PropertyUnitReservationSchedule,
    PropertyUnitDocuments,
    PropertyUnitServiceCharges,
    PropertyTypes,
    Projects,
    PaymentTypes,
    UnitTypes,
    Countries,
    PropertiesDDL,
    MasterBankDDL,
    MasterEmirateDDL,
    BankTransactions,
    PaymentMonths,
    configReducer,
    form: formReducer,
    masterParameters,
    masterDDL,
    db_Ids,
    ui_Ids,
    local_payroll_values,
    ReportGroupsDDL,
    ReportsDDL,
    ReportDetails,
    Masters,
    MastersTblDDL,
    Users,
    Managers,
    MasterTasks,
    Reports,
    UserPermissionsTask,
    Dashboard,
    auth: AuthReducer,
  })(
    action.type === "LOGIN" || action.type === "LOGOUT" ? undefined : state,
    action
  );
export default persistReducer(persistConfig, rootReducer);
// export default rootReducer;
